import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { EcReceiptDetail_ManagementECPage_Query } from "./query";

type Props = {
	hotelID: string;
	receiptID: string;
};

export const useSuspenseFetchEcReceiptByReceiptID = ({ hotelID, receiptID }: Props) => {
	const { data } = useCustomSuspenseQuery(EcReceiptDetail_ManagementECPage_Query, {
		variables: {
			hotelID,
			receiptID,
		},
	});

	return { data };
};
